module.exports = __webpack_public_path__ + "img/qr-menu-mobile-light.72465ed2.svg";